import { Component, Input } from '@angular/core';

@Component({
    selector: 'cmps-scorecard-trend-section',
    template: `
        <div class="cmps-scorecard-trend-section-container">
            <div class="cmps-scorecard-trend-section-item">
                <span class="cmps-scorecard-trend-section-label">{{
                    previousScoreLabel
                }}</span>
                <span class="cmps-scorecard-trend-section-value">{{
                    previousScore
                }}</span>
            </div>
            <div class="cmps-scorecard-trend-section-item">
                <span class="cmps-scorecard-trend-section-label">{{
                    percentChangeLabel
                }}</span>
                <span
                    class="cmps-scorecard-trend-section-value"
                    [style.color]="trendColor"
                >
                    {{ percentChange }}
                </span>
            </div>
        </div>
    `,
    host: {
        class: 'cmps-scorecard-trend-section',
    },
})
export class ScoreTrendSectionComponent {
    @Input() previousScoreLabel: string;
    @Input() previousScore: number;
    @Input() percentChangeLabel: string;
    @Input() percentChange: string;
    @Input() trendColor: string;
}
